import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const ACCESS_TOKEN_CORE_FIELDS = gql`
  fragment AccessTokenCoreFields on AccessToken {
    id
    token
    name
    createdAt
    inactiveAt
    isViewable
  }
`;

export const ACCESS_TOKEN_FIELDS = gql`
  ${ACCESS_TOKEN_CORE_FIELDS}
  fragment AccessTokenFields on AccessToken {
    ...AccessTokenCoreFields
    dealer {
      id
      label
    }
  }
`;

export const ACCESS_TOKEN = gql`
  ${ACCESS_TOKEN_FIELDS}
  query AccessToken ($id: ID!) {
    accessToken (id: $id) {
      ...AccessTokenFields
    }
  }
`;

export const ACCESS_TOKENS = gql`
  ${ACCESS_TOKEN_FIELDS}
  query AccessTokens (
    $limit: Int!
    $offset: String!
    $options: ConnectionOptionsInput!
  ) {
    accessTokens (
      first: $limit
      after: $offset
      options: $options
    ) {
      edges {
        node {
          ...AccessTokenFields
        }
      }
      totalCount
    }
  }
`;

export const CREATE_ACCESS_TOKEN = gql`
  ${ACCESS_TOKEN_CORE_FIELDS}
  mutation CreateAccessToken (
    $dealerId: ID!
    $name: String
  ) {
    createAccessToken (
      dealerId: $dealerId
      name: $name
    ) {
      accessToken {
        ...AccessTokenCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_ACCESS_TOKEN = gql`
  ${ACCESS_TOKEN_CORE_FIELDS}
  mutation UpdateAccessToken (
    $id: ID!
    $name: String
  ) {
    updateAccessToken (
      id: $id
      name: $name
    ) {
      accessToken {
        ...AccessTokenCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const INACTIVATE_ACCESS_TOKEN = gql`
  ${ACCESS_TOKEN_CORE_FIELDS}
  mutation InactivateAccessToken ($id: ID!) {
    inactivateAccessToken (id: $id) {
      accessToken {
        ...AccessTokenCoreFields
      }
      ${ERRORS}
    }
  }
`;
